import React from 'react';
import PropTypes from 'prop-types';

import Form from 'components/form/form';
import TextInput from 'components/form-elements/text-input';
import HiddenInput from 'components/form-elements/hidden-input';
import Button from 'components/button';
import PageSpinner from 'components/page-spinner';
import ValidationErrorTexts from 'components/validation-error-texts';

const NotifyMeForm = ({
  endpoint,
  validationEndpoint,
  validationErrors,
  recaptchaSiteKey,
  emailInputLabel,
  emailInputPlaceholder,
  formButtonLabel,
  cancelLabel,
  selectedProductValues,
  onResponse,
  onCancel,
  formKey
}) => {
  return (
    <Form
      endpoint={endpoint}
      validationEndpoint={validationEndpoint}
      validationErrors={validationErrors}
      recaptchaSiteKey={recaptchaSiteKey}
      key={formKey}
      fieldNameMapping={{ 'notify-me-email': 'email' }}
      showSubmitButton={false}
      onResponse={onResponse}
      className="notify-me-form"
    >
      {({ isLoading }) => (
        <>
          <PageSpinner shouldContainInParent={true} isLoading={isLoading} />
          {selectedProductValues &&
            Object.entries(selectedProductValues).map(([name, value]) => (
              <HiddenInput key={name} name={name} value={value} />
            ))}
          <div className="notify-me-form__content">
            <TextInput
              validations="isRequired,isEmail"
              validationErrors={validationErrors}
              type="email"
              autocomplete="email"
              name="notify-me-email"
              label={emailInputLabel}
              placeholder={emailInputPlaceholder}
              theme={TextInput.themes.bordered}
              shouldSetValueOnChange={true}
              className="notify-me-form__email-input"
            />
          </div>
          <div className="notify-me-form__actions">
            <Button
              type="submit"
              text={formButtonLabel}
              className="notify-me-form__action-btn"
            />
            <Button
              onClick={onCancel}
              text={cancelLabel}
              className="notify-me-form__action-btn"
              theme={Button.themes.outlineGray}
            />
          </div>
        </>
      )}
    </Form>
  );
};

NotifyMeForm.propTypes = {
  endpoint: PropTypes.string.isRequired,
  validationEndpoint: PropTypes.string,
  validationErrors: PropTypes.exact(ValidationErrorTexts.propTypes),
  recaptchaSiteKey: PropTypes.string,
  emailInputLabel: PropTypes.string,
  emailInputPlaceholder: PropTypes.string,
  formButtonLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  selectedProductValues: PropTypes.object,
  onResponse: PropTypes.func,
  onCancel: PropTypes.func,
  formKey: PropTypes.number
};

NotifyMeForm.propTypesMeta = {
  emailInputLabel: 'exclude',
  emailInputPlaceholder: 'exclude',
  formButtonLabel: 'exclude',
  cancelLabel: 'exclude',
  selectedProductValues: 'exclude',
  onResponse: 'exclude',
  onCancel: 'exclude',
  formKey: 'exclude'
};

export default NotifyMeForm;
